const skills = [
  {
    id: 1,
    title: "Programming",
    content: ["C", "C++", "Python", "Javascript", "Typescript"],
    bgStart: "rgb(225, 150, 58)",
    bgEnd: "rgb(227, 144, 91)",
  },
  {
    id: 2,
    title: "FrontEnd",
    content: ["HTML", "CSS", "ReactJs", "ViteJs"],
    bgStart: "rgb(93, 94, 170)",
    bgEnd: "rgb(93, 66, 103)",
  },
  {
    id: 3,
    title: "Backend",
    content: ["ExpressJs", "NodeJs"],
    bgStart: "#ff5252",
    bgEnd: "#b33939",
  },
  {
    id: 4,
    title: "Databases",
    content: ["SQL", "DBMS", "MongoDB"],
    bgStart: "rgb(225, 150, 58)",
    bgEnd: "rgb(227, 144, 91)",
  },
  {
    id: 5,
    title: "Data Viz",
    content: ["Plotly.js", "D3.js"],
    bgStart: "rgb(93, 94, 170)",
    bgEnd: "rgb(93, 66, 103)",
  },
  {
    id: 6,
    title: "Cloud",
    content: ["Docker"],
    bgStart: "#ff5252",
    bgEnd: "#b33939",
  },
  {
    id: 7,
    title: "Testing Tools",
    content: ["Selenium", "Cucumber"],
    bgStart: "rgb(93, 94, 170)",
    bgEnd: "rgb(93, 66, 103)",
  },
  {
    id: 8,
    title: "Tools",
    content: ["Git", "Github", "Figma", "Gitlab", "Bootstrap"],
    bgStart: "rgb(93, 94, 170)",
    bgEnd: "rgb(93, 66, 103)",
  },
  {
    id: 9,
    title: "Operating Systems",
    content: ["Linux", "Windows"],
    bgStart: "#ff5252",
    bgEnd: "#b33939",
  },
];

export default skills;
